// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.carousel[data-v-3689e896] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    margin-left: 90px;\n    max-width: 100%;\n    width: 100%;\n    height: 100%;\n    -o-object-fit: cover;\n       object-fit: cover;\n    overflow: hidden;\n    background-size: cover !important;\n}\n", ""]);
// Exports
module.exports = exports;
